import {OttopilotContestStatus} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotContestsWorkspaceCapability/domain/OttopilotContest";
import {OttopilotEventContainerStatus} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainer";
import {OrganizationalUnitStatus} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/organizationalUnitsWorkspaceCapability/domain/OrganizationalUnit";

export function contestStatusToDisplayName(contestStatus: OttopilotContestStatus): string {
    switch (contestStatus) {
        case OttopilotContestStatus.active: {
            return "Active";
        }
        case OttopilotContestStatus.archived: {
            return "Archived";
        }
        case OttopilotContestStatus.draft: {
            return "Draft";
        }
        default: {
            console.error("Invalid contestStatus", contestStatus);
            return "Unknown";
        }
    }
}

export function eventContainerStatusToDisplayName(status: OttopilotEventContainerStatus): string {
    switch (status) {
        case OttopilotEventContainerStatus.active: {
            return "Active";
        }
        case OttopilotEventContainerStatus.archived: {
            return "Archived";
        }
        default: {
            console.error("Invalid eventContainerStatus", status);
            return "Unknown";
        }
    }
}

export function organizationalUnitStatusToDisplayName(organizationalUnitStatus: OrganizationalUnitStatus): string {
    switch (organizationalUnitStatus) {
        case OrganizationalUnitStatus.active: {
            return "Active";
        }
        case OrganizationalUnitStatus.deleted: {
            return "Deleted";
        }
        default: {
            console.error("Invalid organizationalUnitStatus", organizationalUnitStatus);
            return "Unknown";
        }
    }
}
